import {
  QuestionnaireComponentKind,
  QuestionnaireFormComponentRegistry,
} from '../component-registry';
import { DynamicFormFieldConfig } from '../field-registry';

export function findFieldFromConfig(
  config: readonly DynamicFormFieldConfig<QuestionnaireFormComponentRegistry>[],
  fieldName: string,
) {
  const stack = [config];
  let fields: readonly DynamicFormFieldConfig<QuestionnaireFormComponentRegistry>[] | undefined;

  while ((fields = stack.pop())) {
    for (const field of fields) {
      if (field.name === fieldName) {
        return field;
      }

      if (field.kind === QuestionnaireComponentKind.Section && field.fields) {
        stack.push(field.fields);
      }
    }
  }

  return;
}
